import { useConfigStore } from '~/store/config'
import { storeToRefs } from 'pinia'

export const getConfig = () => {
  const configStore = useConfigStore()
  const { config } = storeToRefs(configStore)
  return config.value
}
